<template>
  <c-input-container
    class="c-input"
    v-bind="$attrs"
  >
    <c-input-raw
      v-bind="$attrs"
      @update:modelValue="$emit('update:modelValue', $event)"
      v-on="componentListeners"
    />
  </c-input-container>
</template>

<script>
import useVue3Migration from '@convenia/composables/useVue3Migration'
import CInputContainer from '@convenia/components/CInputContainer'
import CInputRaw from './fragments/CInputRaw'

export default {
  name: 'CInput',
  components: { CInputRaw, CInputContainer },

  setup (_, ctx) {
    const {
      componentListeners,
    } = useVue3Migration(ctx)

    return {
      componentListeners,
    }
  },

  emits: [
    'input',
    'update:modelValue'
  ]
}
</script>
